import React from "react";

//interfaces
import SimpleTableMenu from "../SimpleTableMenu/SimpleTableMenu";

//hooks
import { ISimpleRow } from "../../../../../interfaces/tables/ISimpleTable";



const SimpleRow = ({row, rowIndex, setControlIndex, isControlIndex, hasControlsColumn}: ISimpleRow) => {
    const hasControls: boolean = row.controls?.some(control => control.content !== undefined) ?? false;
    
    return (
        <tr className={'rc-simple-row'}>
            {row.content.map((cell: any, cellIndex: number) => (
                <td key={rowIndex-cellIndex}>{cell}</td>
            ))}

            {hasControls 
                ?   (<SimpleTableMenu 
                        isControlIndex={isControlIndex} 
                        setControlIndex={setControlIndex} 
                        buttons={row.controls} 
                    />)
                :   hasControlsColumn && <td />
            }
        </tr>
    );
};

export default SimpleRow;